<template>
    <div>
        <el-form ref="form" :inline="true" class="query-form" size="mini" @submit.native.prevent="onSubmit">
            <el-form-item label="月份：" class="query-form-item">
                <el-date-picker v-model="query.date" type="month" value-format="yyyyMM"
                                style="width: 110px" :clearable="false"/>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" icon="search" @click="onSubmit" native-type="submit">查询</el-button>
            </el-form-item>
        </el-form>
        <el-table :loading="loading" :data="list" :height="tableHeight" size="mini" ref="multipleTable"
                  class="table_content mini_div selectionStatisticsTable" style="width: 100%;"
                  :span-method="spanMethod" :row-class-name="tableRowClassName"
        >
            <el-table-column label="运营人员" width="200" align="center">
                <template slot-scope="scope">
                    <div class="fixedHeight">{{ scope.row.name || '-' }}</div>
                </template>
            </el-table-column>
            <el-table-column label="合计" width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, 'all', false)"></div>
                </template>
            </el-table-column>
            <el-table-column label="数量" width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, 'all_count')"></div>
                </template>
            </el-table-column>
            <el-table-column prop="category" label="国家" width="80" align="center"/>

            <el-table-column label="待处理" width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '待处理')"></div>
                </template>
            </el-table-column>

            <el-table-column label="新品测试" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '新品测试')"></div>
                </template>
            </el-table-column>

            <el-table-column label="新品推广-重点产品" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '新品推广-重点产品')"></div>

                </template>
            </el-table-column>

            <el-table-column label="推广期" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '推广期')"></div>

                </template>
            </el-table-column>

            <el-table-column label="老品" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '老品')"></div>

                </template>
            </el-table-column>

            <el-table-column label="需要核对情况" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '需要核对情况')"></div>

                </template>
            </el-table-column>

            <el-table-column label="卖完不卖" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '卖完不卖')"></div>

                </template>
            </el-table-column>

            <el-table-column label="不在运营" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '不在运营')"></div>
                </template>
            </el-table-column>

            <el-table-column label="结束" min-width="170" align="center">
                <template slot-scope="scope">
                    <div v-html="getDiffDom(scope.row, '结束')"></div>
                </template>
            </el-table-column>
        </el-table>

    </div>
</template>

<script>
import * as api from '@/api/advAnalys/advAnalys.js'
import { downloadFileUrl } from '@/utils/method'
import { getRunningStates } from '@/api/common/common.js'

export default {
    name: 'categoryStatistics',
    computed: {
        // 扁平化数据结构，方便合并单元格
        flatTableData() {
            const result = []
            this.mergeMap = {} // 记录每个人需要合并几行
            this.list.forEach((person) => {
                this.mergeMap[person.full_name] = person.items.length
                person.items.forEach((item, idx) => {
                    result.push({
                        ...item,
                        full_name: idx === 0 ? person.full_name : '',
                        total: idx === 0 ? person.total : '',
                        buyingTotal: idx === 0 ? person.buyingTotal : '',
                        buyingTotal1: idx === 0 ? person.buyingTotal1 : '',
                        completeTotal: idx === 0 ? person.completeTotal : '',
                        begin_total: idx === 0 ? person.begin_total : '',
                        begin_buyingTotal: idx === 0 ? person.begin_buyingTotal : '',
                        begin_buyingTotal1: idx === 0 ? person.begin_buyingTotal1 : '',
                        begin_completeTotal: idx === 0 ? person.begin_completeTotal : '',
                    })
                })
            })
            return result
        },
    },
    watch: {
        tableHeight(val) {
            this.tableHeight = val
        },
    },
    data() {
        return {
            // 国家映射：由接口 getRunningStates 动态获取
            countryObj: {},
            // 国家列表（接口返回原始数据）
            runningStateList: [],
            categoryList: [],
            peopleListVisible: false,
            rootCategoryList: [],
            usList: [],
            ukList: [],
            deList: [],
            imgStatusList: [
                {name: '全部', value: undefined},
                {name: '搜索不到图片', value: 1},
                {name: '暂无图片', value: 2},
                {name: '有图片', value: 3},
            ],
            isFold: true,
            editType: 0,
            copyData: {},
            manualRootShow: false,
            showBasicConfigDataModal: false,
            showAddParseModal: false,
            showCategoryList: false,
            manualRootList: [],
            showAddRecord: false,
            currentId: '',
            tableHeight: null,
            errorMsg: '',
            errorInfoShow: false,
            ctrl: {
                DownloadListDialogVisible: false,
                uploadDialogVisible: false,
                bidDialogVisible: false,
                childInfoVisible: false,
            },
            query: {
                date: undefined,
                page: 1,
                limit: 10,
                total: 0,
            },
            record_id: 0,
            activeName: 'antiInternal',
            list: [],
            disabled: false,
            listDisabled: false,
            loading: false,
            parseStatusList: [],
            updateData: {},
            childInfo: {},
            multipleSelection: [],
        }
    },
    mounted() {
        this.query.date = this.getCurrentMonth()
        this.initRunningStates()
        this.tableHeight =
            window.innerHeight - 140 - this.$refs.form.$el.offsetHeight
        const that = this
        window.onresize = () => {
            return (() => {
                if (typeof that.$refs.form == 'object') {
                    that.tableHeight =
                        window.innerHeight -
                        140 -
                        that.$refs.form.$el.offsetHeight
                }
            })()
        }
    },
    methods: {
        async initRunningStates() {
            try {
                const res = await getRunningStates({})
                if (res && res.code === 0) {
                    const list = Array.isArray(res.data) ? res.data : []
                    this.runningStateList = list
                    // { us: '美国', ... }
                    this.countryObj = list.reduce((acc, cur) => {
                        if (cur && cur.state) acc[cur.state] = cur.cn_state || cur.state
                        return acc
                    }, {})
                } else {
                    this.runningStateList = []
                    this.countryObj = {}
                }
                this.getList()
            } catch (e) {
                this.runningStateList = []
                this.countryObj = {}
            }
        },
        tableRowClassName({row, rowIndex}) {
            // 根据国家数量动态分组（每N行为一组）
            const groupSize = this.getGroupSize()
            const groupIndex = Math.floor(rowIndex / groupSize)
            return groupIndex % 2 === 0 ? 'group-even' : 'group-odd'
        },
        // 获取当前月份，格式为 'YYYY-MM'
        getCurrentMonth() {
            const now = new Date()
            const year = now.getFullYear()
            const month = String(now.getMonth() + 1).padStart(2, '0')
            return `${year}${month}`
        },
        getGroupSize() {
            // 国家数量（兜底为4，避免接口异常导致除0）
            const size = Object.keys(this.countryObj || {}).length
            return size > 0 ? size : 0
        },
        spanMethod({ rowIndex, columnIndex }) {
            // 只对第0列“运营人员”、第1列“合计”进行合并
            if ([0, 1].includes(columnIndex)) {
                const groupSize = this.getGroupSize()
                if (rowIndex % groupSize === 0) {
                    return { rowspan: groupSize, colspan: 1 }
                }
                return { rowspan: 0, colspan: 0 }
            }
        },
        getDiffDom(data, key, needStart = true) {
            let percentage = (data[key] === 0 ? 0 : (data[key] / data.all_count) * 100)
            // 默认保留两位小数；但如果刚好是 100%，显示为 100%（不保留小数）
            if (percentage === 0) {
                percentage = 0
            } else if (Number(percentage.toFixed(2)) === 100) {
                percentage = '100%'
            } else {
                percentage = percentage.toFixed(2) + '%'
            }
            let start = needStart ? (percentage === 0 ? '' : `[${percentage}]`) : ''
            const num = (data[key] || 0) - (data['last_' + key] || 0)
            const colorStr = num > 0 ? 'green' : num < 0 ? 'red' : ''
            const arrow = num > 0 ? '↑' : num < 0 ? '↓' : ''
            const style = `color: ${colorStr}; font-weight: bold;`
            const appendStr = num !== 0 ? `(${arrow}${Math.abs(num)})` : ''
            return `<span style="${style}">${start}${data[key]}${appendStr}</span>`
        },
        mergePersonCells({rowIndex, columnIndex}) {
            // 需要合并的列：人员、合计、采购中合计、采购完成合计
            const colsToMerge = [0]
            if (!colsToMerge.includes(columnIndex)) return

            const row = this.flatTableData[rowIndex]
            if (!row.name) {
                return {rowspan: 0, colspan: 0}
            }

            const rowspan = this.getGroupSize()
            return { rowspan, colspan: 1 }
        },
        getNumDiff(obj, variableStr, preStr) {
            let res = {flag: false, num: 0}
            if (obj.begin_date_datas && obj.end_date_datas) {
                res = {flag: true, num: obj.end_date_datas[variableStr] - obj.begin_date_datas[variableStr]}
            }
            return res
        },

        // 操作
        operateFunc(data, type) {
            let tempDate = JSON.parse(JSON.stringify(data))
            this.editType = type
            this.copyData = tempDate
            this.showAddRecord = true
        },

        /**
         * 数字相乘
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accMul(arg1, arg2) {
            let m = 0
            m = this.accAdd(m, this.getDecimalLength(arg1))
            m = this.accAdd(m, this.getDecimalLength(arg2))
            return this.getNum(arg1) * this.getNum(arg2) / Math.pow(10, m)
        },
        getNum(arg = '') {
            return Number(arg.toString().replace('.', ''))
        },
        /**
         * 数字相加
         * @param {*} arg1
         * @param {*} arg2
         * @returns
         */
        accAdd(arg1, arg2) {
            return this.changeNum(arg1, arg2)
        },
        changeNum(arg1 = '', arg2 = '', isAdd = true) {
            const changeInteger = (arg, r, maxR) => {
                if (r != maxR) {
                    let addZero = ''
                    for (let i = 0; i < maxR - r; i++) {
                        addZero += '0'
                    }
                    arg = Number(arg.toString().replace('.', '') + addZero)
                } else {
                    arg = this.getNum(arg)
                }
                return arg
            }

            let r1, r2, maxR, m
            r1 = this.getDecimalLength(arg1)
            r2 = this.getDecimalLength(arg2)
            maxR = Math.max(r1, r2)
            arg1 = changeInteger(arg1, r1, maxR)
            arg2 = changeInteger(arg2, r2, maxR)
            m = Math.pow(10, maxR)
            if (isAdd) {
                return (arg1 + arg2) / m
            } else {
                return (arg1 - arg2) / m
            }
        },

        getDecimalLength(arg = '') {
            try {
                return arg.toString().split('.')[1].length
            } catch (e) {
                return 0
            }
        },

        getList() {
            this.loading = true
            api.statistics_statistics_kpi_teambition_operator(this.query).then(response => {
                this.loading = false
                if (response.code === 0) {
                    let arr = []
                    const keys = Object.keys(response.data || {})
                    for (const tempKey of keys) {
                        const item = response.data[tempKey]
                        const localKeys = Object.keys(item.current_date_datas || {})
                        let obj = {}
                        let all = 0
                        let last_all = 0
                        let items = []
                        for (const keyItem of localKeys) {
                            all += (item.current_date_datas[keyItem].all_count || 0)
                            obj.name = item.full_name
                            obj.category = this.countryObj[keyItem] || keyItem
                            item.current_date_datas[keyItem] && Object.assign(obj, item.current_date_datas[keyItem])
                            obj.last_category = this.countryObj[keyItem] || keyItem
                            if (item.last_date_datas) {
                                const lastKyes = Object.keys(item.last_date_datas[keyItem] || {})
                                last_all += (item.last_date_datas[keyItem].all_count || 0)
                                for (const lastKey of lastKyes) {
                                    obj['last_' + lastKey] = item.last_date_datas[keyItem][lastKey]
                                }
                            }
                            items.push(JSON.parse(JSON.stringify(obj)))
                        }
                        items = items.map(item=>{
                            item.all = all
                            item.last_all = last_all
                            return item
                        })
                        arr = arr.concat(items)
                    }
                    this.list = arr
                } else {
                    this.$message({
                        type: 'error',
                        message: res.message
                    })
                }
            }).catch(() => {
                this.loading = false
            })
        },
        formatDate(date) {
            const yyyy = date.getFullYear()
            const mm = String(date.getMonth() + 1).padStart(2, '0') // 月份从0开始，所以要加1
            const dd = String(date.getDate()).padStart(2, '0')
            return `${yyyy}-${mm}-${dd}`
        },
        clickRowHandle(row, column) {
            if (['标题', '类目树', '子类目', '1688产品标题', '颜色'].includes(column.label)) {
                this.childInfo.title = column.label
                let info = row.title
                if (column.label == '类目树') {
                    info = row.category_tree
                } else if (column.label == '子类目') {
                    info = row.categories_str
                } else if (column.label == '颜色') {
                    info = row.color
                } else if (column.label == '1688产品标题') {
                    info = row.ali_title
                }
                this.childInfo.info = info
                this.ctrl.childInfoVisible = true
            }
            if (['折叠', '收起'].includes(column.label)) {
                this.isFold = !this.isFold
            }
        },
        clickHeaderHandle(row, column) {
            if (['折叠', '收起'].includes(row.label)) {
                this.isFold = !this.isFold
            }
        },
        handleSortChange(val) {
            if (val.order == 'ascending') {
                this.query.desc = 'desc'
                this.query.order = val.prop
            } else if (val.order == 'descending') {
                this.query.desc = 'asc'
                this.query.order = val.prop
            }
            this.getList()
        },
        handleClick(tab) {
            this.$nextTick(() => {
                this.$refs[tab.paneName].getList()
            })
        },
        //重置
        onReset() {
            this.query = {
                dataRange: 7,
                begin_date: undefined,
                end_date: undefined,
                category_state: '',
                category_id: '',
                page: 1,
                limit: 10,
                total: 0,
            }
            this.getList()
        },
        onBatchDistribution() {
            if (this.multipleSelection.length > 0) {
                this.peopleListVisible = true
            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        //查询
        onSubmit() {
            this.query.page = 1
            this.getList()
        },
        basicData() {
            this.showBasicConfigDataModal = true
        },
        addParse() {
            this.showAddParseModal = true
        },
        // 批量删除
        batchDelete() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量删除已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_delete({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '删除成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },
        // 批量重置
        batchReset() {
            if (this.multipleSelection.length > 0) {
                this.$confirm(`确定批量重置已选择项吗?`, {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    api.variety_cost_control_analysis_batch_reset({ids: this.multipleSelection}).then(res => {
                        if (res.code === 0) {
                            this.$message({type: 'success', message: '重置成功'})
                            this.getList()
                        } else {
                            this.$message({type: 'error', message: res.message})
                        }
                    }).catch(res => {
                        this.$message({type: 'error', message: res.message})
                    })
                }).catch(() => {
                })

            } else {
                this.$message.info('暂未选择批量处理内容')
            }
        },

        change() {
            this.getList()
        },
        clearValue() {
            this.query.state = ''
        },
        //分页
        handleCurrentChange(val) {
            this.query.page = val
            this.getList()
        },
        handleSizeChange(val) {
            this.query.limit = val
            this.getList()
        },
        //上传文件
        onupload() {
            this.ctrl.uploadDialogVisible = true
        },
        //下载列表
        onDownloadList() {
            this.ctrl.DownloadListDialogVisible = true
            this.$nextTick(() => {
                this.$refs[this.activeName].getList()
            })
        },
        // bid记录列表
        openBidList(data) {
            this.currentId = data.id
            this.ctrl.bidDialogVisible = true
        },
        async startDecode(row, force = 0) {
            if (force) {
                await this.$confirm('是否重新运行解析任务', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                })
            }
            let list = JSON.parse(JSON.stringify(this.list))
            api.variety_cost_control_analysis_parsing_file({
                id: row.id,
                force
            }).then(() => {
                const index = list.findIndex(item => item.id === row.id)
                list[index].status = 1
                this.list = list
            })
        },
        downFile(path) {
            if (!path) {
                return this.$message({
                    type: 'error',
                    message: '无法下载！'
                })
            }
            downloadFileUrl(path)
        },
        //添加广告优化记录
        onAddPpc(data) {
            this.record_id = data.id
            this.ctrl.addPpcDialogVisible = true
        },
        // 关闭弹窗回调
        closeCllback(isShow) {
            this.showAddRecord = false
            this.showAddParseModal = false
            this.ctrl.childInfoVisible = false
            this.updateData = {}
            isShow == true && this.getList()
        },
        // 关闭弹窗回调
        chooseDevelopCloseCallback(arr) {
            this.peopleListVisible = false
            if (arr.length > 0) {
                api.manager_cost_analysis_manager_batch_distribution({
                    ids: this.multipleSelection,
                    developer_id: arr[0]
                }).then(res => {
                    if (res.code === 0) {
                        this.$message.success('分配成功')
                        this.getList()
                    } else {
                        this.$message({type: 'error', message: res.message})
                    }
                }).catch(res => {
                    this.$message({type: 'error', message: res.message})
                })
            }
        },
        refreshList() {
            this.getList()
        },
        update(data) {
            this.updateData = data
            this.showAddRecord = true
        }
    }
}
</script>

<style type="text/scss" lang="scss" scoped>
.redTxt {
    color: red;
    font-weight: bold;
}

.greenTxt {
    color: green;
    font-weight: bold;
}

.fixedHeight {
    height: 30px;
    line-height: 15px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    display: flex;
    justify-content: center;
    align-items: center;
}

.mini_div .el-button--mini {
    padding: 5px 5px !important;
}

/deep/ .el-table__expanded-cell {
    padding: 0 0 !important;
}

/deep/ .group-even {
    background-color: #e8f5e9;
}

/deep/ .group-odd {
    background-color: #e3f2fd;
}
</style>
